export const environment = {
    appName: "ANGULAR_BASE_CODE",
    production: false,
    apiUrl: 'https://dev-api.urwa.net/', // dev
    apiPrefix: 'api/v1',
    media_domain: 'https://d3pammvaye9mt0.cloudfront.net/development', // dev

    OneSignalAppId: "23756584-45d5-4283-847b-ef7a4c43132e",
    redirectUrl: 'https://dev.urwa.net',
    cookieDomain: '.urwa.net',
  //dev

  firebase: {
    apiKey: "AIzaSyDV_Mvr2o61llCgAMpQxxtvjx_L9EYytGc",
    authDomain: "urwa-app.firebaseapp.com",
    databaseURL: "https://urwa-app-default-rtdb.firebaseio.com",
    projectId: "urwa-app",
    storageBucket: "urwa-app.firebasestorage.app",
    messagingSenderId: "840289540806",
    appId: "1:840289540806:web:28793f084bf558f5d195c7",
    measurementId: "G-DK3KJ7HNN9"
  }
}